module.exports = __webpack_public_path__ + "static/media/Diana_Paola_Espinosa_Fuentes.7db325e6.jpg";